import routes from "../common/api-routes";
import {HttpAuthPost, HttpAuthGet, HttpAuthPutParamsPayload, HttpAuthPutParams} from "../../../../core/services/common/HttpRequestBuilder";

const listBooking = (parameters) => {
    let result = HttpAuthGet(routes.GET_LIST_BOOKING, parameters);
    return result;
}

const viewBooking = (parameters) => {
    let result = HttpAuthGet(routes.VIEW_BOOKING, parameters);
    return result;
}

const createBooking = (payload) => {
    let result = HttpAuthPost(routes.CREATE_BOOKING, payload);
    return result;
}

const updateBooking = (parameters, payload) => {
    let result = HttpAuthPutParamsPayload(routes.UPDATE_BOOKING, parameters, payload);
    return result;
}

const getBookingTypes = () => {
    let parameters = null;
    let result = HttpAuthGet(routes.GET_BOOKING_TYPES, parameters);
    return result;
}

const updateBookingStatus = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_BOOKING_STATUS, parameters);
    return result;
}

const getBookingStatusList = () => {
    let parameters = null;
    let result = HttpAuthGet(routes.GET_BOOKING_STATUS_LIST, parameters);
    return result;
}

const filterBooking = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_BOOKING, parameters);
    return result;
}


const BookingService = {
    listBooking: listBooking,
    viewBooking: viewBooking,
    createBooking: createBooking,
    updateBooking: updateBooking,
    getBookingTypes: getBookingTypes,
    updateBookingStatus: updateBookingStatus,
    getBookingStatusList: getBookingStatusList,
    filterBooking: filterBooking,
}

export default BookingService